<template>
  <v-card class="quiz-result">
    <v-card-text>
      <span class="title font-weight-light mb-2">
        Question {{ questionIndex + 1 }}
      </span>
      <p v-html="quiz.logged_question"></p>
      <span class="title font-weight-light mb-2">Answer</span>
      <p>{{ quiz.answer.data }}</p>
    </v-card-text>
    <v-card-actions class="pt-0" style="align-items: flex-end;">
      <div class="pl-1" v-if="userType === 'teacher'">
        <span class="learning-area-label font-weight-light mb-2">
          Learning Areas:
        </span>
        <v-chip
          v-for="(area, index) in learningAreas"
          :key="`la-${index}`"
          color="primary"
          label
          outlined
          class="mr-2"
        >
          <v-icon left>school</v-icon>{{ area.name | capitalize }}
        </v-chip>
      </div>
      <v-spacer />
      <div
        :class="[
          'result-chip',
          quiz.answer.is_correct ? 'correct' : 'incorrect'
        ]"
      >
        <div class="icon-container">
          <v-icon color="white" class="icon">{{
            quiz.answer.is_correct ? 'check' : 'close'
          }}</v-icon>
        </div>
        <span>{{ quiz.answer.is_correct ? 'CORRECT' : 'INCORRECT' }}</span>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'QuizResult',
  props: {
    quiz: {
      type: Object,
      required: true
    },
    questionIndex: {
      type: Number,
      required: true
    },
    userType: {
      type: String,
      default: 'student'
    }
  },
  data() {
    return {}
  },
  watch: {},
  computed: {
    learningAreas() {
      return this.quiz.lesson_slide.learning_areas
    }
  },
  methods: {}
}
</script>

<style lang="scss">
.quiz-result {
  padding-bottom: 10px;

  span.title {
    display: block;
    color: black;
  }

  .learning-area-label {
    display: block;
  }

  .result-chip {
    position: relative;
    border: 1px solid #ccc;
    width: 130px;
    border-radius: 4px;

    &.correct {
      background-color: white !important;
      .icon-container {
        background: var(--v-correct-base);
      }
    }
    &.incorrect {
      background-color: white !important;
      .icon-container {
        background: var(--v-incorrect-base);
      }
    }
    .icon-container {
      width: 35px;
      height: 35px;
      position: relative;
      display: inline-block;
      vertical-align: middle;
      .icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    span {
      display: inline-block;
      vertical-align: middle;
      line-height: 35px;
      text-align: center;
      width: 90px;
      font-size: 0.875rem;
    }
  }
}
</style>
